import React from "react";
import Image from "../MenuItems/Image";
import Table from "../MenuItems/Table/Table";
import Youtube from "../MenuItems/Youtube/Youtube";

const Advanced = ({ editor, disabled }) => {
	const createTable = (rows, cols) => {
		editor
			.chain()
			.focus()
			.insertTable({ rows, cols, withHeaderRow: true })
			.run();
	};

	const addVideo = href => {
		editor.commands.setYoutubeVideo({ src: href });
	};

	const addImage = href => {
		editor.chain().focus().setImage({ src: href }).run();
	};

	return (
		<>
			<div className={`editor-menu-box`}>
				<Table
					onChange={createTable}
					isActive={editor.isActive("table")}
					isDisabled={disabled}
				/>
				<Image onChange={addImage} isDisabled={disabled} />
				<Youtube onChange={addVideo} isDisabled={disabled} />
			</div>
		</>
	);
};

export default Advanced;
